<template>
  <div>
    <div id="Header-container" class="Header-container">
      <div id="Headers" class="Menu">
        <div id="headerIcon" class="icon"></div>
        <div class="list" @click="clickEve" id="clickBox" ref="clickBoxs">
          <div class="inner"></div>
          <!-- <div
            data-value="7"
            data-path="lifeDetail/1"
            class="clickName item"
            data-name="btns"
            :class="path==='/lifeDetail?id=1'?'active':''"
          >
            生活中的科学
            <p></p>
          </div> -->
          <div
            data-value="6"
            data-path="original"
            class="clickName item"
            data-name="btns"
            :class="path==='/classify?key=original'?'active':''"
          >
            国产原创
            <p></p>
          </div>
          <div
            data-value="5"
            data-path="hot"
            class="clickName item"
            data-name="btns"
            :class="path==='/classify?key=hot'?'active':''"
          >
            热播动画
            <p></p>
          </div>
          <div
            data-value="4"
            data-path="latest"
            class="clickName item"
            data-name="btns"
            :class="path==='/classify?key=latest'?'active':''"
          >
            最新上映
            <p></p>
          </div>
          <div
            data-value="3"
            data-path="ranking"
            class="clickName item"
            data-name="btns"
            :class="path==='/classify?key=ranking'?'active':''"
          >
            动画片排行榜
            <p></p>
          </div>
          <div
            data-value="0"
            data-path="home"
            class="clickName item"
            data-name="btns"
            :class="path==='/index'?'active':''"
          >
            首页
            <p></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tools } from "../tools/index";
export default {
  data() {
    return {
      eveArr: [],
      initDom: {},
      path: this.$route.fullPath
    };
  },
  watch: {
    $route: {
      handler() {
        this.path = this.$route.fullPath;
      },
      deep: true,
    },
  },
  mounted() {
    // this.bindBtnEve();
  },
  methods: {
    clickEve(e) {
      if (!e.target.dataset.value) {
        return false;
      }
      e.stopPropagation();
      e.preventDefault();
      // let childNodes = e.target.parentNode.childNodes;
      // childNodes.forEach(item => {
      //   Tools.removeClass(item, "active");
      // });
      // Tools.addClass(e.target, "active");
      this.Jumpers(e.target.dataset.value);
      this.eveArr = [];
    },
    Jumpers(value) {
      if (value === "0") {
        this.$router.push("/index");
        Tools.removeClass(
          document.getElementById("Header-container"),
          "showBgRouter"
        );
      } else if (value === "1") {
        this.$router.push("/videos");
        Tools.addClass(
          document.getElementById("Header-container"),
          "showBgRouter"
        );
      } else if (value === "2") {
        this.$router.push("/downloads");
        Tools.removeClass(
          document.getElementById("Header-container"),
          "showBgRouter"
        );
        Tools.addClass(document.getElementById("Headers"), "isDark");
      } else if (value === "3") {
        this.$router.push("/classify?key=ranking");
        Tools.addClass(
          document.getElementById("Header-container"),
          "showBgRouter"
        );
      }else if (value === "4") {
        this.$router.push("/classify?key=latest");
        Tools.addClass(
          document.getElementById("Header-container"),
          "showBgRouter"
        );
      }else if (value === "5") {
        this.$router.push("/classify?key=hot");
        Tools.addClass(
          document.getElementById("Header-container"),
          "showBgRouter"
        );
      }else if (value === "6") {
        this.$router.push("/classify?key=original");
        Tools.addClass(
          document.getElementById("Header-container"),
          "showBgRouter"
        );
      }else if (value === "7") {
        this.$router.push("/lifeDetail?id=1");
        Tools.addClass(
          document.getElementById("Header-container"),
          "showBgRouter"
        );
      }
    },
    // 按钮绑定事件
    bindBtnEve() {
      let _this = this;
      this.$refs.clickBoxs.onmouseover = function (e) {
        e.stopPropagation();
        e.preventDefault();
        _this.handleEve(e.target.parentNode.children, e.target);
      };
      this.$refs.clickBoxs.onmouseout = function (e) {
        e.stopPropagation();
        e.preventDefault();
        _this.removeEve(
          e.target.parentNode.children,
          Object.assign(_this.eveArr)
        );
        _this.eveArr = [];
      };
    },
    // 获得当前的所有节点中哪个是被激活的状态
    getEleActive(pNode) {
      if (!pNode) {
        return false;
      }
      let _this = this;
      Array.isArray(pNode) && pNode?.forEach((item) => {
        if (item.classList.contains("active")) {
          _this.eveArr.push(item);
        }
      });
    },
    // 处理子节点中所有按钮绑定的事件
    handleEve(pNode, cNode) {
      if (typeof pNode === "undefined") {
        return false;
      }
      if (pNode.length === 0) {
        console.warn("所提供的父节点为空", pNode);
        return false;
      }
      if (typeof cNode === "undefined") {
        console.warn("所提供的子节点无效", cNode);
        return false;
      }
      if (
        typeof cNode.dataset === "undefined" ||
        typeof cNode.dataset.name === "undefined"
      ) {
        console.warn("所提供的节点不是子节点");
        return false;
      }
      this.getEleActive(pNode);
      Array.isArray(pNode) && pNode?.forEach((item) => {
        item.classList.remove("active");
      });
      cNode.classList.add("active");
    },
    // 绑定默认节点中的事件
    removeEve(pNode, cNode) {
      if (cNode.length === 0) {
        return false;
      }
      if (
        typeof cNode[0].dataset === "undefined" ||
        typeof cNode[0].dataset.name === "undefined"
      ) {
        return false;
      }
      Array.isArray(pNode) && pNode?.forEach((item) => {
        item.classList.remove("active");
      });
      cNode[0].classList.add("active");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../pages/base.scss";

.Header-container {
  width: vw(1920px);
  display: inline-block;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  height: vh(80px);
  position: fixed;
  top: vh(0px);
  left: vw(0px);
  z-index: 999;
  transition: all 200ms;
  text-align: center;
  // background-image: url('../assets/images/lianghui.png');
  // margin: 0 auto;
  // min-width: 1152px;
  // max-width: 2560px;
  // background-position: top;
  // background-size: 1920px auto;
  // background-repeat: no-repeat;
}

.Header-container.showBg {
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.Header-container.showBg .Menu .list .clickName {
  color: rgba(51, 51, 51, 1) !important;
  // vertical-align: top;
  height: vh(80px);
  line-height: vh(80px);
  float: right;
}
.Header-container.showBg .Menu .list .clickName.active {
  color: #8bbb50 !important;
}
.Header-container.showBg .Menu .btns div {
  // border: 1px solid rgba(153, 153, 153, 1) !important;
  // color: rgba(51, 51, 51, 1) !important;
  // vertical-align: top;
}
.Header-container.showBg .Menu .btns .register {
  color: #ffffff !important;
}
.Header-container.showBg .Menu .btns .Login {
  border-color: #8bbb50 !important;
  color: #8bbb50 !important;
}
.Header-container.showBgRouter {
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.Header-container.showBgRouter .Menu .list .clickName {
  color: rgba(51, 51, 51, 1) !important;
  float: right;
}
.Header-container.showBgRouter .Menu .list .clickName.videos {
  color: #8bbb50 !important;
}
.Header-container.showBgRouter .Menu .icon {
  background-image: url("../assets/images/logo.png") !important;
}
.Header-container.showBg .Menu .icon {
  background-image: url("../assets/images/logo.png") !important;
}
.Header-container.showBgRouter .Menu .btns div {
  // border: 1px solid rgba(153, 153, 153, 1) !important;
  // color: rgba(51, 51, 51, 1) !important;
}
.Header-container.showBgRouter .Menu .btns .register {
  background-color: #8bbb50 !important;
  color: #ffffff !important;
}
.Header-container.showBgRouter .Menu .btns .Login {
  border-color: #8bbb50 !important;
  color: #8bbb50 !important;
}
.Header-container .Menu .list .clickName {
  font-size: fz(20px);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  // line-height: vh(28px);
  display: inline-block;
  cursor: pointer;
  position: relative;
  margin-left: vw(88px);
  vertical-align: top;
  height: vh(80px);
  line-height: vh(80px);
  float: right;
}

.Header-container .Menu.isDark .list .clickName {
  color: #ffffff;
}

.Header-container .Menu .list .clickName.active {
  font-weight: 600;
}
.Header-container .Menu .list .clickName.active.download p {
  // background-color: #ffffff;
}
.Header-container .Menu .list .clickName p {
  background-color: #8bbb50;
  width: 0;
  height: vh(3px);
  transition: all 200ms ease;
  overflow: hidden;
  margin: 0 auto;
  position: absolute;
  top: vh(65px);
  left: 50%;
  margin-left: vw(-10px);
}

.Header-container .Menu .list .clickName.active p {
  width: vw(20px);
  height: vh(3px);
  position: absolute;
  top: vh(65px);
}

.Header-container .Menu .list .clickName:hover p {
  width: vw(20px);
  font-weight: 600;
}

.Header-container .Menu {
  // width: vw(1200px);
  display: inline-block;
  height: vh(80px);
  background-color: rgba(255, 255, 255, 0);
  position: fixed;
  top: vh(0px);
  left: 50%;
  margin-left: vw(-700px);
}

.Header-container .Menu .icon {
  width: vw(132px);
  display: inline-block;
  height: vh(40px);
  background-image: url("../assets/images/logo.png");
  background-size: 100% 100%;
  position: absolute;
  top: 50%;
  margin-top: vh(-20px);
  left: 0px;
}
.Header-container .Menu.isDark .icon {
  background-image: url("../assets/images/miki_logo_tabx2.png");
}
.Header-container .Menu .list {
  width: vw(1500px);
  display: inline-block;
  overflow: hidden;
  height: vh(80px);
  line-height: vh(80px);
}

.Header-container .Menu .btns {
  display: inline-block;
  width: vw(165px);
  height: vh(80px);
  line-height: vh(80px);
  position: absolute;
  right: 0px;
  top: vh(-1px);
  white-space: nowrap;
}

.Header-container .Menu.isDark .btns .register {
  background-color: #8bbb50;
  border-color: #8bbb50;
  color: white;
}
.Header-container .Menu.isDark .btns .Login {
  border-color: #ffffff;
  color: white;
}
.Header-container .Menu .btns div {
  display: inline-block;
  width: vw(70px);
  height: vh(30px);
  border-radius: 15px;
  border: 1px solid rgba(153, 153, 153, 1);
  line-height: vh(28px);
  font-size: fz(16px);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  cursor: pointer;
}
.Header-container .Menu .btns .register {
  background-color: #8bbb50;
  border-color: #8bbb50;
}
.Header-container .Menu .btns.isDark div {
  color: #ffffff;
  border: 1px solid #ffffff;
}

.Header-container .Menu .btns div {
  margin-left: vw(25px);
}

.Header-container .Menu .btns div:hover {
  // background: rgba(139, 187, 80, 1);
  // color: rgba(255, 255, 255, 1);
  // border: 1px solid rgba(139, 187, 80, 1);
}

.Header-container .Menu .list .inner {
  /* width: 865px;display: inline-block; */
  width: vw(351px);
  display: inline-block;
  vertical-align: top;
}
</style>